<template>
    <div>
        <div class="flex md:ml-5">
        <span v-if="fixCountryCode"
              class="px-3 py-2 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline">
        +
        </span>
            <input
                id="checkout_phone_number"
                v-model="currentCountryCode"
                type="tel"
                autocomplete="phone_number_country_code"
                @keyup="countryCodeOnKeyup"
                class="px-3 py-2 w-1/6 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                style="width: 50px"
                :class="{ 'is-invalid': errors && (errors['phone_number.country_code'] || errors['phoneNumber.countryCode']) }"
            >
            <input
                class="px-3 py-2 w-1/6 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                v-model="currentPrefix"
                id="phonePrefix"
                ref="phonePrefix"
                @keyup="onKeyup"
                type="tel"
                :maxlength="currentPrefixLength"
                autocomplete="phone_number_prefix"
                style="width: 50px"
                :class="{ 'is-invalid': errors && (errors['phone_number.prefix'] || errors['phone_number.prefix']) }">
            <input
                class="px-3 py-2 text-sm w-4/6 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                v-model="currentLineNumber"
                type="tel"
                ref="lineNumber"
                :maxlength="currentLineNumberLenght"
                autocomplete="phone_number_line_number"
                :class="{ 'is-invalid': errors && (errors['phone_number.line_number'] || errors['phone_number.line_number']) }">
        </div>


        <form-error
            field="phone_number.countryCode"
            :errors="errors"
        />
        <form-error
            field="phone_number.country_code"
            :errors="errors"
        />
        <form-error
            field="phone_number.prefix"
            :errors="errors"
        />
        <form-error
            field="phone_number.line_number"
            :errors="errors"
        />
        <form-error
            field="phoneNumber.prefix"
            :errors="errors"
        />
        <form-error
            field="phoneNumber.lineNumber"
            :errors="errors"
        />
        <form-error
            field="phoneNumber.countryCode"
            :errors="errors"
        />
        <form-error
            field="phoneNumber.country_code"
            :errors="errors"
        />
    </div>
</template>

<script>
import MultiFormError from '@webapix/shop-js/src/components/MultiFormError'

export default {
    name: 'PhoneNumberField',

    components: {MultiFormError},

    props: {
        fixCountryCode: {
            type: String,
            default: null
        },

        countryCode: {
            type: String,
            default: ''
        },

        prefix: {
            type: String,
            default: null
        },

        defaultCountryId: {
            type: Number,
            default: null
        },

        lineNumber: {
            type: String,
            default: null
        },
        errors: {
            type: Object,
            default: null
        },
    },

    data() {
        return {
            currentCountryCode: this.fixCountryCode ? this.fixCountryCode : this.countryCode,
            currentPrefix: this.prefix,
            currentLineNumber: this.lineNumber,
            phoneDefaultCountryId: window.phoneCountryId,
        }
    },

    computed: {
        errorFields() {
            return [
                'phone_number',
                'phone_number.country_code',
                'phone_number.prefix',
                'phone_number.line_number',
                'phoneNumber',
                'phoneNumber.countryCode',
                'phoneNumber.prefix',
                'phoneNumber.lineNumber',
            ]
        },

        currentPrefixLength() {
          if(this.defaultCountryId == this.phoneDefaultCountryId) {
              return window.currentPrefixLength
          }

          return null
        },

        currentLineNumberLenght() {
            if(this.defaultCountryId == this.phoneDefaultCountryId) {
                return window.currentLineNumberLenght
            }

            return null
        },
    },

    watch: {
        currentCountryCode() {
            this.emitNewValue()
        },
        currentPrefix() {
            this.emitNewValue()
        },
        currentLineNumber() {
            this.emitNewValue()
        },
    },

    created() {
        this.emitNewValue()
    },

    methods: {
        emitNewValue() {
            this.$emit('input', {
                countryCode: this.currentCountryCode,
                prefix: this.currentPrefix,
                lineNumber: this.currentLineNumber
            })
        },

        countryCodeOnKeyup() {
            if (this.currentCountryCode.length == 2) {
                this.$refs.phonePrefix.focus()
            }
        },

        onKeyup() {
            if (this.currentPrefix.length == this.currentPrefixLength) {
                this.$refs.lineNumber.focus()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.phone-number-line-number {
    width: 60px !important;
}

.phone-number-field {
    float: right;
}
</style>
